// extracted by mini-css-extract-plugin
export default {"faqSection":"styles_faqSection__hNuGb","title":"styles_title__BWsIN"};